import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import sl from 'vuetify/es5/locale/sl'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },

    lang: {
        locales: { sl },
        current: 'sl',
    },

    theme: {
        themes: {
            /*light: {
                primary: "#4527A0",
                secondary: "#512DA8",
                tertiary: "#512DA8",
                accent: '#8c9eff',
                error: '#b71c1c',
                background: '#fafafa'
            },*/
            /*light: {
                primary: "#016184",
                secondary: "#36738a",
                tertiary: "#36738a",
                accent: '#8c9eff',
                error: '#b71c1c',
                background: '#fafafa'
            },*/

            
            light: {
                primary: "#0072bc",
                secondary: "#0072bc",
                tertiary: "#36738a",
                accent: '#8c9eff',
                error: '#b71c1c',
                background: '#fafafa'
            }
        },
    },
});
